import { useContext } from 'react';
import { CropAdjustmentDispatch } from './Contexts';
import { DragInterfaceContext } from './MouseDragProvider';


export default function VerticalCropAdjustmentLayer({setLiveSide, ...props}){

  let sides = ["top","bottom"];
  let { startDrag } = useContext(DragInterfaceContext);

  const { setCropResizeInfo, onMouseMove, onDragEnd } = useContext(CropAdjustmentDispatch);

  return (
    <>
    {sides.map(side => (
        <div 
          item={"crop-resizer"}
          side={side}
          class="crop-resizer blue-hoverable hoverable-sibling"
          onClick={e => e.stopPropagation()}
          onMouseDown={e => {
            e.stopPropagation();

            setLiveSide(side);


            setCropResizeInfo(props);

            startDrag({
              event:e,
              onMouseMove,
              side,
              ...props,
              onDragEnd,
              toNullify:[
                setCropResizeInfo,
                setLiveSide,
              ],
            });

            //
            //setTempInlineCrop(inlineCrop);
          }}

          style={{position:'absolute',width:'100%',
            height:3,
            [side]:0,
            left:0,
            zIndex:10,
            cursor:'ns-resize'
          }}/>
      ))}
      <div style={{
        //background:'rgb(200,200,200,0.5)'
      }} class="absolute-cover visible-on-sibling-hover"/>
    </>
  )
}

  /*
        {canResizeCropVertically &&  <div class="crop-resizer blue-hoverable hoverable-sibling" 
          side={"bottom"}
          item={"crop-resizer"}
          onMouseDown={e => {
            //;
            e.stopPropagation();
            setCropResizeInfo(cropResizeStarterPackage(e,'bottom'))
            setTempInlineCrop(inlineCrop);
          }}
          onClick={e => e.stopPropagation()}
          style={{
            position:'absolute',width:'100%',height:3,
            //background:(thisCropBeingAdjusted && cropResizeInfo?.side === 'bottom' ? 'magenta' : defaultLineColor),
            bottom:0,left:0,zIndex:10,cursor:'ns-resize'}}/>}
            */

        

